import { DateTimeUtils } from "dyl-components";
import { getDefaultCartItems } from "shared/schemas/cart/cartSchema";
import { ObjectUtils, StringUtils } from "utils";

export const DYL_ACCOUNT_ID = 1;

export const getQuoteDefaultValues = ({ quote }) => {
    const { state } = quote.contact_info?.address || {};

    const cartItems = getDefaultCartItems(quote.quote_summary.map(item => ({
        ...item,
        product_discount: item.item_discount?.discount || 0,
        discount_cycle: item.item_discount?.discount_cycle || 1,
        life_time_discount: item.item_discount?.life_time_discount || false,
        max_discount: item.product_discount
    })));
    const schedules = [...new Set(cartItems.filter(item => item.schedules.length).map(item => item.pricing_schedule))];
    return {
        quote_status: quote.quote_status,
        cart: cartItems,
        name: quote.name,
        from_email: quote.from_information?.email,
        from_phone: quote.from_information?.phone,
        from_user_id: quote.from_information?.from_user_id,
        profile_info: quote.from_information?.profile_info,
        contact_email: quote.contact_info?.email,
        contact_email_type: quote.contact_info?.email_type,
        contact_phone: quote.contact_info?.phone,
        contact_phone_type: quote.contact_info?.phone_type,
        contact_id: quote.contact_info?.contact_id,
        contact_address:
            state
                ? {
                    ...quote.contact_info?.address,
                    label: StringUtils.capitalize(quote.contact_info?.address_type)
                }
                : {
                    additional_street: "",
                    city: "",
                    state: "",
                    street: "",
                    zip: "",
                },
        expires:
            quote.expires > 0
                ? DateTimeUtils.changeFormat(
                      DateTimeUtils.convertUnixTimeToDate(quote.expires, "UTC"),
                      "",
                      DateTimeUtils.WORD_DATE_FORMAT,
                      "UTC"
                  )
                : null,
        notes: quote.note,
        pricing_schedule: schedules.length === 1 ? schedules[0] : null
    };
};

export const getOrderDefaultValues = ({ order, account_id, account_term, action }) => {
    const shippingAddress = order?.shipping_address?.location?.address;
    const customer_account_discounts = order?.customer_account_discounts || [];
    const order_status = order?.order_status || "draft";
    const cartItems = getDefaultCartItems(order?.order_items?.map(item => {
        const customer_account_discount = customer_account_discounts.find(discount => discount.product_id === item.product_id)
        const item_discount = item.item_discount?.discount || 0
        const discount_cycle = item.item_discount?.discount_cycle || 0
        const life_time_discount = item.item_discount?.life_time_discount || false
        return ({
            ...item,
            product_discount: (order_status === 'completed' || order_status === "cancelled" || order_status === "deleted") ? item_discount : customer_account_discount?.discount || item_discount,
            max_discount: item.product_discount,
            discount_cycle: (order_status === 'completed' || order_status === "cancelled" || order_status === "deleted") ? discount_cycle : customer_account_discount?.remaning_billing_cycles || item.discount_cycle || 1,
            life_time_discount: (order_status === 'completed' || order_status === "cancelled" || order_status === "deleted") ? life_time_discount : customer_account_discount?.life_time_discount || item.life_time_discount || false,
        });
    }) || [], account_term);
    const schedules = [...new Set(cartItems.filter(item => item.schedules.length).map(item => item.pricing_schedule))];
    return {
        isShippingSameAsBilling:
            shippingAddress &&
            order?.shipping_address?.location?.contact_id ===
                order?.billing_address?.contact_id &&
            ObjectUtils.deepEqual(
                shippingAddress,
                order?.billing_address?.address
            ),
        order_status,
        order_name: order?.name,
        billing_address: Object.keys(order?.billing_address || {}).length
            ? {
                ...order.billing_address,
                address: {
                    ...(order.billing_address.address || {}),
                    label: order.billing_address.address_type
                }
            }
            : {
                  address: {
                      label: "",
                      additional_street: "",
                      city: "",
                      state: "",
                      street: "",
                      zip: "",
                  },
                  contact_id: account_id,
                  email: "",
                  email_type: "",
                  phone: "",
                  phone_type: ""
              },
        shipping_address: Boolean(order?.shipping_address?.location?.address) && Boolean(cartItems.some(item => item.shippable))
            ? {
                  address: {
                    ...(order?.shipping_address?.location?.address || {}),
                    label: order?.shipping_address?.location?.address_type
                  },
                  phone: order?.shipping_address?.location?.phone,
                  phone_type: order?.shipping_address?.location?.phone_type,
                  email: order?.shipping_address?.location?.email,
                  email_type: order?.shipping_address?.location?.email_type,
                  ...(!Boolean(order?.shipping_address?.location?.contact_id)
                      ? (() => {
                            const { first_name, last_name, suffix } = order?.shipping_address?.ship_to;
                            return {
                                contact_id: `shipping-contact`,
                                first_name,
                                last_name,
                                suffix,
                            };
                        })()
                      : {
                            ship_to: order?.shipping_address?.ship_to,
                            contact_id:
                                order?.shipping_address?.location?.contact_id,
                        }),
              }
            : {
                  address: {
                      label: "",
                      additional_street: "",
                      city: "",
                      state: "",
                      street: "",
                      zip: "",
                  },
                  contact_id: account_id,
                  email: "",
                  phone: "",
              },
        cart: cartItems,
        pricing_schedule: account_term || schedules.length === 1 ? schedules[0] : null,
        term: (() => {
            if (Number(account_id) === DYL_ACCOUNT_ID) {
                return "dyl_main";
            }
            if (order?.account?.fund_type === "demo" || action === "demo") {
                return "demo";
            }
            if (order?.account?.fund_type === "trial") {
                return ["trial", order?.trial_period].filter(part => part).join("/");
            }
            return null;
        })()
    };
};
